var map = {
	"./green-button.png": 70,
	"./green-button@2x.png": 71
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 125;


//////////////////
// WEBPACK FOOTER
// ./themes/fq/sprite ^\.\/green\-button.*\.png$
// module id = 125
// module chunks = d-game